import { fg } from '@atlaskit/platform-feature-flags';

export const getStoreMessageHeader = (): { store_message?: string } => {
	if (!fg('kd_sain_enable_arize_hello_only')) {
		return {};
	}
	try {
		const stored = localStorage.getItem('search-ai.sain.store_message');
		const shouldStore = stored === null || stored === 'true';
		return shouldStore ? { store_message: 'true' } : {};
	} catch {
		return { store_message: 'true' };
	}
};
